import React, { useMemo } from 'react';
// import moment from 'moment';
import styles from './DateTable.module.scss';
import DateCeil from './DateCeil';
import { DateCeilType, getHintCeilAry } from './util';

type IProps = {
  ceilAry: DateCeilType[];
  selectedDate: number;
  onSelectDate?: (data: DateCeilType | undefined) => void;
  noticeList: number[];
  taskList: number[];
  today: number;
};
const DateTable: React.FC<IProps> = ({ ceilAry, onSelectDate, selectedDate, noticeList, taskList, today }) => {
  const hintCeilAry = useMemo(() => getHintCeilAry(ceilAry, selectedDate, noticeList, taskList, today), [ceilAry, selectedDate, noticeList, taskList, today]);

  const onClickCeil = (e: React.MouseEvent<HTMLElement>) => {
    const target = e.target as HTMLElement;
    const id = target.getAttribute('data-id') as string;
    const ceilData = ceilAry.find((el) => el.date === Number(id));
    onSelectDate && onSelectDate(ceilData);
  };

  return (
    <div className={styles.dateTable} onClick={onClickCeil}>
      {hintCeilAry.map((el) => {
        return <DateCeil isTask={el.isTask} key={el.date} {...el} />;
      })}
    </div>
  );
};

export default DateTable;
